import { useEffect, useState } from "react";
import { FolderOpen } from "lucide-react";
import api from "@/lib/api";
import { FilesManager } from "@/components/docs/FilesManager";

const COPY = {
  school: "Organize PDFs, Word, Excel and PowerPoint documents in folders. District files are shared with every school; school files are visible to your staff and teachers.",
  care: "Keep care plans, intake packets, policies, menus and activity calendars in folders. Files here are visible to your care home's admins and officers.",
  business: "Keep safety policies, contractor paperwork, SOPs and other documents in folders. Files here are visible to your company's admins and officers.",
};

export default function FilesPage() {
  const [type, setType] = useState("business");
  useEffect(() => { api.get("/me/company").then((r) => setType(r.data?.type || "business")).catch(() => {}); }, []);
  return (
    <div className="p-6 lg:p-8" data-testid="files-page">
      <header className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 inline-flex items-center gap-1.5"><FolderOpen className="h-3.5 w-3.5" /> Documents</div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">Files</h1>
        <p className="text-sm text-slate-500">{COPY[type] || COPY.business}</p>
      </header>
      <FilesManager defaultScope="school" />
    </div>
  );
}
